const LAST_SEEN_UPDATE_ID_STORAGE_KEY = "lastSeenUpdateId";

export function readClientLastSeenUpdateId(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(LAST_SEEN_UPDATE_ID_STORAGE_KEY);
}

export function writeClientLastSeenUpdateId(updateId: string): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LAST_SEEN_UPDATE_ID_STORAGE_KEY, updateId);
}

export function shouldShowUpdatesBanner({
  latestUpdateId,
  lastSeenUpdateId,
}: {
  latestUpdateId: string;
  lastSeenUpdateId: string | null | undefined;
}): boolean {
  if (!latestUpdateId) return false;
  if (!lastSeenUpdateId) return true;
  return lastSeenUpdateId !== latestUpdateId;
}
